import React, { useContext } from 'react';
import { getImage } from 'gatsby-plugin-image';
import ButtonNav from './elements/ButtonNav';
import Location from './Location';
import Slider from 'react-slick';
import { ConfiguratorContext } from '../context/ConfiguratorProvider';
import { getCategoryPath } from './utils/get-category-path';

import { locationsWrap } from './locations.module.scss';
import './slick-carousel.scss';

const Locations = ({
  // getCategoryPath,
  locationsData,
  isSingleVenue = false,
  isSearch = false,
  hasPagination,
  isSlide,
  className,
}) => {
  const [isDev] = useContext(ConfiguratorContext);

  // TODO: remove these functions
  const onClickPreviousVenue = () => {
    // console.log('PREVIOUS BTN');
  };
  const onClickNextVenue = () => {
    // console.log('NEXT BTN');
  };

  function NextArrow(props) {
    const { onClick } = props;
    // const { className, style, onClick } = props;
    return (
      // <div
      //   className={className}
      //   style={{ ...style, display: 'block', background: 'red' }}
      //   onClick={onClick}
      // />
      <ButtonNav next="true" onClick={onClick} />
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;
    // const { className, style, onClick } = props;
    return (
      // <div
      //   className={className}
      //   style={{ ...style, display: 'block', background: 'green' }}
      //   onClick={onClick}
      // />
      <ButtonNav previous="true" onClick={onClick} />
    );
  }
  const swipeSettings = {
    dots: false,
    // centerMode: true,
    infinite: true,
    speed: 350,
    // slidesToShow: 4,
    slidesToScroll: 2,
    swipeToSlide: true,
    initialSlide: 1,
    className: className ? className : 'slidewrapper',
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          // infinite: true,
          // initialSlide: 0,
          slidesToShow: 2,
          // infinite: true,
          // dots: false,
        },
      },
      // {
      //   breakpoint: 810,
      //   settings: {
      //     infinite: true,
      //     initialSlide: 0,
      //     slidesToShow: 2,
      //     // slidesToScroll: 1,
      //     // initialSlide: 2,
      //   },
      // },
      // {
      //   breakpoint: 640,
      //   settings: {
      //     infinite: true,
      //     initialSlide: 0,
      //     slidesToShow: 2,
      //     // dots: true,
      //     // centerMode: false,
      //     // centerPadding: 0,
      //     // swipeToSlide: true,
      //     // slidesToScroll: 1,
      //   },
      // },
      {
        breakpoint: 640,
        settings: {
          // infinite: true,
          // initialSlide: 0,
          slidesToShow: 2,
          slidesToScroll: 1,
          // dots: true,
          // centerMode: false,
          // centerPadding: 0,
          // swipeToSlide: true,
          // slidesToScroll: 1,
        },
      },
      {
        breakpoint: 638,
        settings: {
          // infinite: true,
          // initialSlide: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          // dots: true,
          centerMode: false,
          centerPadding: 0,
          // swipeToSlide: true,
          // slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={locationsWrap}>
      {/* <pre>Locations</pre> */}
      {isDev && <pre>Locations</pre>}
      {isSlide ? (
        <Slider {...swipeSettings}>
          {locationsData && !isSingleVenue
            ? locationsData.map((location) => {
                // Extract slug values from the nodes array
                const categorySlugs = location.node.categories.nodes.map(
                  (node) => node.slug
                );
                // Set proper URI
                const categoryPath = getCategoryPath(categorySlugs);
                const locationUri = `/${categoryPath}/${location.node.slug}/`;

                // set featured image
                let image;
                if (location.node.featuredImage !== null) {
                  image = getImage(location.node.featuredImage.node.localFile);
                } else {
                  image = '';
                }
                return (
                  <Location
                    key={location.node.title}
                    title={location.node.title}
                    excerpt={location.node.excerpt}
                    image={image}
                    locationUri={locationUri}
                    // locationUri={location.node.uri}
                    leImageVenue={location.node.locationsACF.leImageVenue}
                    isSlide={true}
                  />
                );
              })
            : ''}
          {locationsData && isSingleVenue
            ? locationsData.map((location) => {
                // Extract slug values from the nodes array
                const categorySlugs = location.categories.nodes.map(
                  (node) => node.slug
                );

                // Set proper URI
                const categoryPath = getCategoryPath(categorySlugs);
                const locationUri = `/${categoryPath}/${location.slug}/`;

                // set featured image
                let image;

                if (location.featuredImage !== null) {
                  image = getImage(location.featuredImage.node.localFile);
                } else {
                  image = '';
                }
                return (
                  <Location
                    key={location.title}
                    title={location.title}
                    excerpt={location.excerpt}
                    image={image}
                    locationUri={locationUri}
                    // locationUri={location.uri}
                    leImageVenue={location.locationsACF.leImageVenue}
                    isSlide={true}
                  />
                );
              })
            : ''}
        </Slider>
      ) : (
        !isSearch && (
          <ul>
            {hasPagination && (
              <>
                <ButtonNav
                  previous="true"
                  onClickPrevious={onClickPreviousVenue}
                />
                <ButtonNav next="true" onClickNext={onClickNextVenue} />
              </>
            )}
          </ul>
        )
      )}
      {/* Search */}
      {isSearch
        ? locationsData &&
          locationsData.map((location) => {
            // Extract slug values from the nodes array
            const categorySlugs = location.node.categories.nodes.map(
              (node) => node.slug
            );
            // Set proper URI
            const categoryPath = getCategoryPath(categorySlugs);
            const locationUri = `/${categoryPath}/${location.node.slug}/`;

            // set featured image
            let image;
            if (location.node.featuredImage !== null) {
              image = getImage(location.node.featuredImage.node.localFile);
            } else {
              image = '';
            }
            return (
              <Location
                key={location.node.title}
                title={location.node.title}
                excerpt={location.node.excerpt}
                image={image}
                locationUri={locationUri}
                // locationUri={location.node.uri}
                leImageVenue={location.node.locationsACF.leImageVenue}
                isSlide={true}
              />
            );
          })
        : ''}
    </div>
  );
};

export default Locations;
